<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue'
import type { PostOrPage } from '@tryghost/content-api'
import PostList from './PostList.vue'
import { getCategoryFromTag } from '../getCategories'
import '@cypress-design/vue-spinner/style.css'
import Spinner from '@cypress-design/vue-spinner'

const blogPosts = ref<PostOrPage[]>([])
const errorText = ref<string | undefined>()

onMounted(async () => {
  const res = await fetch(`/ghost-drafts`)
  if (res.status === 404) {
    errorText.value = '404 - Page Not found'
    return
  }
  try {
    const resJson = await res.json()
    if (resJson.errors) {
      errorText.value = resJson.errors.map((e: { message: string }) => e.message).join(', ')
    }
    blogPosts.value = resJson.posts
  } catch (e: any) {
    errorText.value = e.message
  }
})

const blogPostsWithCategory = computed<(PostOrPage & { category: string })[]>(() => {
  return blogPosts.value.map((post) => {
    return {
      ...post,
      category: post.primary_tag ? (getCategoryFromTag(post.primary_tag.slug) ?? '') : '',
    }
  })
})
</script>

<template>
  <div v-if="errorText" class="blog-content mx-auto mt-[92px] w-[800px] text-red-500">
    <p>{{ errorText }}</p>
  </div>
  <PostList v-else-if="blogPostsWithCategory.length" :posts="blogPostsWithCategory" draft />
  <div v-else class="blog-content mx-auto flex h-[400px] items-center justify-center"><Spinner /></div>
</template>
